import { useMutation, useQuery } from "@tanstack/react-query";
import { axiosSecured } from "../../api/axiosClient";
import { RETRY_DELAY } from "../../utils/constants";
import { HEALTH_CHECK, WARMUP_DB } from "../appLoader/api/init-api";

const useInitApi = () => {
  const {
    data: healthCheckData = {},
    isLoading: isCheckingHealth,
    refetch: checkHealth,
    isError: isHealthCheckError,
  } = useQuery({
    queryKey: ["checkHealth"],
    queryFn: () =>
      axiosSecured
        .get(HEALTH_CHECK)
        .then((res) => res?.data?.data)
        .catch(console.error),
    retry: 3,
    retryDelay: RETRY_DELAY,
    enabled: false,
  });

  const {
    mutateAsync: warmupDB,
    isPending: isWarmingUpDB,
    isError: isWarmupDBError,
  } = useMutation({
    mutationFn: () =>
      axiosSecured
        .post(WARMUP_DB)
        .then((res) => res?.data)
        .catch(console.error),
  });

  return {
    checkHealthApi: {
      get: checkHealth,
      isLoading: isCheckingHealth,
      data: healthCheckData,
      error: isHealthCheckError,
    },
    warmupDBApi: {
      get: warmupDB,
      isLoading: isWarmingUpDB,
      error: isWarmupDBError,
    },
  };
};

export default useInitApi;
